import React from "react";
import styles from "./style.module.scss";
import { Avatar, Text } from "@evvve/ui-kit";
import avatar_skeleton from "src/assets/images/avatar_skeleton.png";

type Props = {
  avatarUrl?: string | null;
  username?: string | null;
}

export default function ParticipantItem({ avatarUrl, username }: Props) {
  return (
    <div className={styles.wrap}>
      <div
        className={styles.inner}
      >
        <Avatar
          src={avatarUrl || avatar_skeleton}
          size="m"
          alt={`Icon: ${username}`}
          className={styles.avatar}
          status="offline"
        />
        <div className={styles.info}>
          {username && <Text as={"span"} size="m" color="violet">{username}</Text>}
        </div>
      </div>
    </div>
  );
}